/**
 * Traducción de un fallo de autenticación a un mensaje para el usuario.
 *
 * Extraída de `useAuthStore.js` (Ola 10, punto 10-20).
 */

const POR_ESTADO = {
  401: 'Email o contraseña incorrectos.',
  429: 'Demasiados intentos. Inténtalo de nuevo más tarde.',
};

export const mensajeDeError = (error) => {
  const estado = error.response?.status;

  // El 400 lo genera la validación del servidor y su mensaje es el útil.
  if (estado === 400) return error.response.data?.error || 'Datos de acceso no válidos.';
  if (POR_ESTADO[estado]) return POR_ESTADO[estado];
  if (estado >= 500) return 'Error del servidor. Inténtalo de nuevo más tarde.';

  if (error.code === 'NETWORK_ERROR' || error.code === 'ERR_NETWORK') {
    return 'No se pudo conectar. Comprueba tu conexión a internet.';
  }

  return error.message || 'Error de autenticación. Comprueba tus credenciales.';
};

export default mensajeDeError;
